import { motion, useReducedMotion } from "framer-motion";
import { useIsDesktop } from "../../hooks/useMediaQuery";

const PRESETS = {
  up: { y: 28, x: 0 },
  right: { y: 0, x: -24 },
  left: { y: 0, x: 24 },
  fade: { y: 0, x: 0 },
};

/**
 * Scroll-entrance primitive. One place defines the site's reveal
 * timing, distance and reduced-motion behaviour.
 */
const Reveal = ({
  as = "div",
  from = "up",
  delay = 0,
  amount = 0.25,
  duration = 0.7,
  className,
  children,
  ...rest
}) => {
  const reduceMotion = useReducedMotion();
  const isDesktop = useIsDesktop();
  const base = PRESETS[from] || PRESETS.up;
  // Shorter travel on phones: the same 28px shift reads as sluggish on a
  // small viewport where elements enter far more often.
  const scale = isDesktop ? 1 : 0.55;
  const offset = { x: base.x * scale, y: base.y * scale };
  const MotionTag = motion[as] || motion.div;

  if (reduceMotion) {
    const Tag = as;
    return (
      <Tag className={className} {...rest}>
        {children}
      </Tag>
    );
  }

  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, ...offset }}
      whileInView={{ opacity: 1, y: 0, x: 0 }}
      viewport={{ once: true, amount }}
      transition={{ duration: isDesktop ? duration : duration * 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
